var _path, _path2, _line, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftReceived(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3702 10.9704L13.5533 11.6501C14.2771 11.8754 14.9679 11.2206 14.7815 10.4858L14.229 8.3072C14.0536 7.61556 13.2165 7.34385 12.6683 7.80063L11.8444 8.48721L10.9727 9.35882C10.457 9.87453 10.6738 10.7536 11.3702 10.9704Z",
    stroke: "#68F4C9",
    strokeWidth: 1.93939
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3803 10.998L17.1971 11.6777C16.4734 11.903 15.7826 11.2481 15.9689 10.5134L16.5215 8.33479C16.6969 7.64315 17.534 7.37144 18.0822 7.82822L18.9061 8.5148L19.7777 9.38641C20.2934 9.90212 20.0767 10.7811 19.3803 10.998Z",
    stroke: "#68F4C9",
    strokeWidth: 1.93939
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.5149,
    y1: 12.606,
    x2: 15.5149,
    y2: 25.212,
    stroke: "#68F4C9",
    strokeWidth: 1.93939
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75734 16.4849H6.78764V17.4546V22.3031C6.78764 23.9097 8.09009 25.2122 9.69674 25.2122H21.3331C22.9397 25.2122 24.2422 23.9097 24.2422 22.3031V17.4546V16.4849H23.2725H7.75734Z",
    stroke: "#0BC196",
    strokeWidth: 1.93939
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75734 16.4848H6.78764V15.5151C6.78764 13.9085 8.09009 12.606 9.69673 12.606H21.3331C22.9397 12.606 24.2422 13.9085 24.2422 15.5151V16.4848H23.2725H7.75734Z",
    stroke: "#0BC196",
    strokeWidth: 1.93939
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftReceived);
export default __webpack_public_path__ + "static/media/giftReceived.e10c820b0098cc287da6463b075ecc48.svg";
export { ForwardRef as ReactComponent };